<div *ngIf="isInvalid() && messages.length" class="help is-danger">
  <p *ngFor="let message of messages" attr.data-e2e="error-{{ errorId }}">
    {{ message }}
  </p>
</div>
